import React from 'react';
import teacher from '../assets/teacher.png';

const AmbedkarTeacher = () => {
  return (
    <div className="w-full min-h-screen relative flex flex-col">
      {/* Title Section */}
      <div className="w-full h-[150px] bg-white flex justify-center items-center px-4 sm:px-6 lg:px-8">
        <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-black text-center max-w-4xl lg:ml-64">
          डॉ. भीमराव अंबेडकर के जीवन में उनके<br className="hidden sm:block" />
          शिक्षक कृष्णाजी केशव अंबेडकर की भूमिका
        </h1>
      </div>

      {/* Main Content Container */}
      <div className="flex-grow bg-[#1D2130] relative">
        <div className="container mx-auto flex flex-col lg:flex-row items-start">
          {/* Image Section */}
          <div className="lg:sticky lg:top-8 w-full lg:w-1/3 p-4 lg:p-8">
            <div className="max-w-xs mx-auto lg:max-w-none">
              <img
                src={teacher}
                alt="Krishna Keshav Ambedkar"
                className="grayscale w-full h-auto object-contain"
                style={{ maxHeight: '70vh' }}
              />
            </div>
          </div>

          {/* Text Content */}
          <div className="w-full lg:w-2/3 p-4 sm:p-6 lg:p-8 text-white">
            <div className="space-y-6 text-justify leading-relaxed">
              <p className="text-base sm:text-lg lg:text-xl">
                डॉ. भीमराव अंबेडकर के जीवन को आकार देने में उनके शिक्षक कृष्णाजी केशव अंबेडकर का महत्वपूर्ण योगदान था। अंबेडकर का वास्तविक उपनाम “सकपाल” था, परंतु जब उनके पिता सुभेदार रामजी सकपाल ने उन्हें सातारा के गवर्नमेंट स्कूल में दाखिला दिलाया, तो उन्होंने अपने गांव के नाम पर उनका नाम “अंबाडवेकर” लिखवाया| स्कूल में शिक्षक कृष्णाजी अंबेडकर ने उन्हें अपना उपनाम दिया, जिससे भीमराव का उपनाम "अंबेडकर" हो गया| इस उपनाम के साथ उनकी पहचान बनी, जो आगे चलकर एक प्रतिष्ठित नाम बना।|
              </p>
              <p className="text-base sm:text-lg lg:text-xl">
                कृष्णाजी केशव अंबेडकर ने न केवल भीमराव को अपना उपनाम दिया, बल्कि उनकी शिक्षा और उनके व्यक्तित्व के निर्माण में भी योगदान दिया| अंबेडकर के जीवन में शिक्षा का महत्व शुरुआत से ही गहरा था, और उनके शिक्षक ने इसमें एक अहम भूमिका निभाई| स्कूल के दौरान मिली शिक्षा ने अंबेडकर के भीतर ज्ञान की भूख को बढ़ाया और आगे चलकर यही शिक्षा सामाजिक और राजनीतिक सुधारों की नींव बनी, जिसके लिए अंबेडकर पूरी दुनिया में जाने जाते हैं|
              </p>
              <p className="text-base sm:text-lg lg:text-xl">
                कृष्णाजी अंबेडकर के मार्गदर्शन में भीमराव का आत्मविश्वास और ज्ञान का दायरा बढ़ा| अंबेडकर ने समाज में हो रहे जातिगत भेदभाव को व्यक्तिगत रूप से अनुभव किया था, और उनके शिक्षक ने इस दर्द को समझा|। उन्होंने अंबेडकर को प्रेरित किया कि वे अपने ज्ञान और शिक्षा के माध्यम से समाज में बदलाव ला सकते हैं| आगे चलकर अंबेडकर ने भारतीय समाज में व्याप्त असमानता के खिलाफ संघर्ष किया और भारतीय संविधान का मसौदा तैयार किया, जो सामाजिक समानता, बंधुत्व और न्याय के सिद्धांतों पर आधारित है|
              </p>
              <p className="text-base sm:text-lg lg:text-xl">
                अंततः, कृष्णाजी अंबेडकर की भूमिका ने डॉ. अंबेडकर के जीवन में एक मजबूत आधारशिला रखी, जिसने उन्हें शिक्षा के प्रति समर्पित बनाया और समाज सुधार के मार्ग पर अग्रसर किया| उनका दिया हुआ "अंबेडकर" नाम न केवल उनकी पहचान बना बल्कि सामाजिक न्याय की लड़ाई में एक प्रतीक भी बन गया
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmbedkarTeacher;
